/**
 * Dialog.js
 * Builds the DialogWindow and sets it's props.
 *
 * @class   Dialog
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import DialogWindow from './DialogWindow';

export default React.createClass({

	propTypes: {
		title: React.PropTypes.string, // Sets the dialog's title.
	},

	getInitialState() {
		return ({

		})
	},

	render() {

		let {
			className,
			title,
			actions,
			animateFromOrigin
		} = this.props;

		if (this.props.trigger) {
			let {
				type,
				text,
				state,
				triggerClass
			} = this.props.trigger
		}

		let classes = ClassNames('lui-dialog');

		return (
			<DialogWindow
				{...this.props}
				ref="dialogWindow"
				actions={this.props.actions}
				className={classes}>

				<h3 className="lui-dialog-title">{this.props.title}</h3>
				<div ref="dialogContent" className="lui-dialog-content">
					{this.props.children}
				</div>

			</DialogWindow>
		);
	},

	dismiss() {
		this.refs.dialogWindow.dismiss();
	},

	show() {
		this.refs.dialogWindow.show();

	},
});



/** WEBPACK FOOTER **
 ** ./src/components/dialog/Dialog.js
 **/